export enum RenewalChangedAddressEnum {
  Coowner1Legal = 'coowner1.legal',
  Coowner2Legal = 'coowner2.legal',
  OwnerHome = 'owner.home',
  OwnerLegal = 'owner.legal',
}
